import appConfig from "@config/app";
import { mtLogger } from "shared-core";

const enableSW = appConfig.IS_PRODUCTION_OR_TEST_ENV || appConfig.DEBUG_SERVICE_WORKER;

// Register the service worker and store its registration
export const serviceWorkerRegistration: Promise<ServiceWorkerRegistration> | undefined = enableSW
  ? new Promise((resolve, reject) => {
      if (!("serviceWorker" in navigator)) {
        reject();
      } else {
        mtLogger.debug("ServiceWorker is supported");

        const registerServiceWorker = (): void => {
          mtLogger.debug("Registering service worker...");
          navigator.serviceWorker
            .register(appConfig.IS_PRODUCTION_OR_TEST_ENV ? "/sw.js" : "/dev-sw.js?dev-sw", {
              scope: "/",
              type: appConfig.IS_PRODUCTION_OR_TEST_ENV ? "classic" : "module",
            })
            .then(reg => {
              // @ts-ignore
              mtLogger.debug("ServiceWorker registered", reg);
              resolve(reg);
            }, reject);
        };

        // Check if document is already loaded
        if (document.readyState === "complete") {
          registerServiceWorker();
        } else {
          window.addEventListener("load", registerServiceWorker);
        }
      }
    })
  : undefined;

const unRegisterServiceWorkerIfDisabled = async (): Promise<void> => {
  if (!serviceWorkerRegistration) {
    mtLogger.warn(
      "Service Worker has been disabled (we're in dev mode and `VITE_DEBUG_SERVICE_WORKER` is not true)"
    );
    const SWRegistration = await navigator.serviceWorker?.getRegistration();
    if (SWRegistration) {
      mtLogger.warn("But there is a Service Worker running (😱)");
      await SWRegistration.unregister();
      mtLogger.warn("It has been successfully removed, but you should (seriously) reload the page");
    }
  }
};

unRegisterServiceWorkerIfDisabled();
